import DefaultActions from './blob_header_default_actions.vue?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import BlameHeader from './blame_header.vue?vue3';
import BlobFilepath from './blob_header_filepath.vue?vue3';
import ViewerSwitcher from './blob_header_viewer_switcher.vue?vue3';
import { RICH_BLOB_VIEWER, SIMPLE_BLOB_VIEWER, BLAME_VIEWER } from './constants';
import TableOfContents from './table_contents.vue?vue3';
export default {
    name: 'BlobHeader',
    components: {
        BlameHeader,
        ViewerSwitcher,
        DefaultActions,
        BlobFilepath,
        TableOfContents
    },
    mixins: [
        glListenersMixin,
        glSlotsMixin
    ],
    props: {
        blob: {
            type: Object,
            required: true
        },
        hideViewerSwitcher: {
            type: Boolean,
            required: false,
            default: false
        },
        isBinary: {
            type: Boolean,
            required: false,
            default: false
        },
        activeViewerType: {
            type: String,
            required: false,
            default: SIMPLE_BLOB_VIEWER
        },
        hasRenderError: {
            type: Boolean,
            required: false,
            default: false
        },
        showPath: {
            type: Boolean,
            required: false,
            default: true
        },
        showPathAsLink: {
            type: Boolean,
            required: false,
            default: false
        },
        overrideCopy: {
            type: Boolean,
            required: false,
            default: false
        },
        showBlameToggle: {
            type: Boolean,
            required: false,
            default: false
        },
        showBlobSize: {
            type: Boolean,
            required: false,
            default: true
        },
        showBlameInfo: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'viewer-changed',
        'copy'
    ],
    data () {
        return {
            viewer: this.hideViewerSwitcher ? null : this.activeViewerType
        };
    },
    computed: {
        isEmpty () {
            return this.blob.rawSize === '0';
        }
    },
    watch: {
        showBlameInfo (newVal) {
            if (!newVal && this.viewer === BLAME_VIEWER) {
                this.viewer = this.activeViewerType;
            }
        },
        viewer (newVal, oldVal) {
            if (newVal !== BLAME_VIEWER && newVal !== oldVal) {
                this.$emit('viewer-changed', newVal);
            }
        }
    },
    methods: {
        proxyCopyRequest () {
            this.$emit('copy');
        }
    },
    RICH_BLOB_VIEWER
};
